import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

export const DeniedVerification = () => {
  const { content, locale } = useConfig();

  useAirKeyTracePageView('denied');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.denied.img.src}`}
      iconSize={content.denied.img.width}
      title={content.denied.title[locale]}
      titleSize={20}
      body={content.denied.description[locale]}
    />
  );
};
